import { MouseEvent, useCallback } from 'react';
import { useHistory } from 'react-router';
import type { Dispatch } from 'redux';
import { connect, useDispatch } from 'react-redux';

import { getIsSticked } from 'CorePackage/HeaderModule/reducers/headerReducer';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { setLawInterfaceAction } from 'CorePackage/MainModule/actions/coreActions';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Button } from 'UIPackage/MainModule/components/Button';
import { ROUTE_ADMIN_USERS, ROUTE_INFO } from 'CorePackage/MainModule/routes/routes';
import { getUserRoleIsAdmin } from 'AuthPackage/MainModule/selectors/authSelectors';
import { getDecisionFormRef } from 'DecisionPackage/MainModule/selectors/decisionSelectors';

import styles from './SwitchButton.module.scss';

const { FZ_248, FZ_294 } = LawInterfacesEnum;

interface ISwitchButtonStoreProps {
  isKnm: boolean;
  isDecision: boolean;
  isSticked: boolean;
  lawInterface: LawInterfacesEnum;
  isAdmin: boolean;
}

const SwitchButtonWithoutStore = ({ isSticked, isKnm, lawInterface, isAdmin, isDecision }: ISwitchButtonStoreProps) => {
  const isPrimaryInterface = lawInterface === FZ_248;
  const history = useHistory();
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const onFzChangeClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      const { fz } = e.currentTarget.dataset;

      if (fz === lawInterface) {
        return;
      }

      history.push(isAdmin ? ROUTE_ADMIN_USERS : ROUTE_INFO);
      dispatch(setLawInterfaceAction(fz as LawInterfacesEnum));
    },
    [dispatch, history, isAdmin, lawInterface],
  );

  const erknmButtonAttributes = {
    ...(isPrimaryInterface && { 'data-active': true }),
  };

  const erpButtonAttributes = {
    ...(!isPrimaryInterface && { 'data-active': true }),
  };

  const wrapperAttributes = {
    ...((isKnm || isDecision) && isSticked && { 'data-hidden': true }),
  };

  return (
    <div className={styles.SwitchButtonWrapper} {...wrapperAttributes}>
      <Button
        color={isPrimaryInterface ? 'primary' : 'default'}
        className={styles.SwitchButton}
        text="ЕРКНМ"
        data-fz={FZ_248}
        type="button"
        onClick={onFzChangeClick}
        {...erknmButtonAttributes}
      />
      <Button
        color={!isPrimaryInterface ? 'primary' : 'default'}
        className={styles.SwitchButton}
        text="ЕРП"
        data-fz={FZ_294}
        type="button"
        onClick={onFzChangeClick}
        {...erpButtonAttributes}
      />
    </div>
  );
};

const mapStateToProps = (state: IRootState): ISwitchButtonStoreProps => ({
  lawInterface: getLawInterface(state),
  isSticked: getIsSticked(state),
  isKnm: !!getKnmFormRef(state),
  isDecision: !!getDecisionFormRef(state),
  isAdmin: getUserRoleIsAdmin(state),
});

export const SwitchButton = connect(mapStateToProps)(SwitchButtonWithoutStore);
